import { useContext } from "react";
import { ContextOperacionType, ContextOperacion } from "src/pages/sistema/RefactorLayout";
import { OperacionLCTCCuentaVista, OperacionLCTCLimiteTipo } from "../types/dto";
import { OperacionLCTCCuentaLimiteFields } from "../types/fields";
import { OperacionLCTC } from "../types/types";
import { OperacionLCTCLimiteFila } from "./OperacionLCTCLimiteFila";
import { PermissionType } from "src/types/security";

interface OperacionLCTCCuentaFilaProps {
    operacion: OperacionLCTC;
    cuenta: OperacionLCTCCuentaVista;
    loadLimitesOptions: () => Promise<OperacionLCTCLimiteTipo[]>;
    refetch: () => void;
}

const OperacionLCTCCuentaFila = ({ cuenta, operacion, loadLimitesOptions, refetch }: OperacionLCTCCuentaFilaProps) => {
    const { permisoTipo } = useContext<ContextOperacionType>(ContextOperacion);


    return (
        <>
            <OperacionLCTCLimiteFila
                key={cuenta.id}
                cuenta={cuenta}
                operacion={operacion}
                loadLimitesOptions={loadLimitesOptions}
                refetch={refetch}
                permiteModificar={cuenta[OperacionLCTCCuentaLimiteFields.PermiteModificar] && permisoTipo >= PermissionType.Write}
            />
        </>
    );

};

export default OperacionLCTCCuentaFila;
